// Nofence account session detection. A logged-in staff user carries the
// account.nofence.no session cookie; the /api/open/session/ endpoint reports
// `is_staff` for it. Both the map (data fetch path) and the burger menu (gating
// staff-only tools) rely on this, so it lives here as the single source.

// In dev, hit the local proxy (src/setupProxy.js) which attaches your session
// cookie server-side — sidesteps CORS + httpOnly/SameSite. In prod, call the
// real hosts directly (same-site with grazingmap.nofence.no).
export const ENVS =
  process.env.NODE_ENV === "development"
    ? ["/papi-prod", "/papi-staging"]
    : ["https://account.nofence.no", "https://account-staging.nofence.no"]

export async function isStaffOnEnv(base: string): Promise<boolean> {
  return fetch(`${base}/api/open/session/`, { method: "GET", credentials: "include" })
    .then((response) => (response.ok ? response.json() : { is_staff: false }))
    .then((body) => !!body.is_staff)
    .catch(() => false)
}

// True when the browser holds a valid logged-in Nofence account cookie on any
// environment (prod or staging).
export async function checkLoggedIn(): Promise<boolean> {
  const sessions = await Promise.all(ENVS.map(isStaffOnEnv))
  return sessions.some(Boolean)
}
